export const pcPageConfig = {
  "title": "Active",
  "titleCN": "活跃",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/engagement/active",
  "defaultTab": "activeUsers",
  "tabList": [
    {
      "id": "activeUsers",
      "tabName": "Active Users",
      "tabNameCN": "基础分析",
      "isHaveNotification": true,
      "notificationPath": "/engagement/active/activeUsers",
      "path": "/engagement/active/activeUsers",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200701",
        "pageName": "engaementActiveActiveUsers",
        "extInfo": "engaementActiveActiveUsers",
        "pagePath": "/engagement/active/activeUsers"
      },
      "filters": [
        {
          "name": "ActiveUsersFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/engagement/active/activeUsers",
          "componentList": [
            {
              "name": "ActiveUsersTrendCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/engagement/active/metrics"
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "margin-b-10 margin-t-10",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "ActiveUsersCardCo",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "type": "dau"
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "ActiveUsersCardCo",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "type": "pcu_acu"
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "ActiveUsersCardCo",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "type": "dau_breakdown",
                              "tooltipConfig": {}
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "ActiveUsersCardCo",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "type": "dau_systems",
                              "tooltipConfig": {}
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "RankListTabCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "data": {
                    "regionDataType": "country",
                    "tabOrder": [
                      "country",
                      "os",
                      "region"
                    ]
                  },
                  "children": [
                    {
                      "name": "CommonRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/engagement/active/countries_region_zone",
                          "metric": "dau",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "componentMetrics": {
                            "reqMetricKey": "active",
                            "metricKey": "value",
                            "enName": "DAU",
                            "cnName": "日活跃用户",
                            "enWeekName": "WAU",
                            "cnWeekName": "周活跃用户",
                            "enMonthName": "MAU",
                            "cnMonthName": "月活跃用户",
                            "rangeEnName": "Avg.DAU",
                            "rangeCnName": "日平均活跃",
                            "rangeEnWeekName": "Avg.WAU",
                            "rangeCnWeekName": "周平均活跃",
                            "rangeEnMonthName": "Avg.MAU",
                            "rangeCnMonthName": "月平均活跃",
                            "prefix": "Avg",
                            "type": "int",
                            "decimal": 0,
                            "percentDecimals": 0,
                            "comShowConfig": {
                              "isHaveBar": true,
                              "isHaveLine": true,
                              "isHavePie": true,
                              "isHaveShare": true
                            },
                            "showConfig": {
                              "showTable": true,
                              "showChart": true
                            }
                          },
                          "comConfig": {
                            "isHaveBar": true,
                            "isHaveLine": true,
                            "isHavePie": true,
                            "isHaveShare": true
                          },
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            },
            {
              "name": "DAULevelDistributionCo",
              "className": "margin-t-10",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/engagement/active/dau_level_distribution",
                  "componentMetrics": {
                    "enName": "DAU Level Distribution",
                    "cnName": "日活跃用户等级分布",
                    "enWeekName": "WAU Level Distribution",
                    "cnWeekName": "周活跃用户等级分布",
                    "enMonthName": "MAU Level Distribution",
                    "cnMonthName": "月活跃用户等级分布",
                    "type": "int",
                    "decimal": 0
                  }
                }
              }
            }
          ]
        }
      ]
    },
    {
      "id": "onlineAnalysis",
      "tabName": "Playtime Analysis",
      "tabNameCN": "在线分析",
      "isHaveNotification": true,
      "notificationPath": "/engagement/active/onlineAnalysis",
      "path": "/engagement/active/onlineAnalysis",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200702",
        "pageName": "engaementActiveOnlineAnalysis",
        "extInfo": "engaementActiveOnlineAnalysis",
        "pagePath": "/engagement/active/onlineAnalysis"
      },
      "filters": [
        {
          "name": "ActiveOnlineFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/engagement/active/onlineAnalysis",
          "componentList": [
            {
              "name": "AveragePlaytimeTrendCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "titleEn": "Average Playtime",
                  "titleCn": "平均在线时长",
                  "api": "/api/v1/dashboard/pc/engagement/active/aot",
                  "componentMetrics": [
                    {
                      "metricKey": "aot_hour",
                      "enName": "Average Playtime(h)",
                      "cnName": "平均在线时长(小时)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "aot_per_login_hour",
                      "enName": "Average session length(h)",
                      "cnName": "单次登录平均在线时长(小时)",
                      "type": "decimals",
                      "decimal": 2
                    }
                  ]
                }
              }
            },
            {
              "name": "AveragePlaytimeTrendCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "isMedian": true,
                  "titleEn": "Median Playtime",
                  "titleCn": "在线时长中位数",
                  "api": "/api/v1/dashboard/pc/engagement/active/median_playtime",
                  "componentMetrics": [
                    {
                      "metricKey": "median_online_time",
                      "enName": "Median Playtime(h)",
                      "cnName": "在线时长中位数(小时)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "median_session_time",
                      "enName": "Median Session Length(h)",
                      "cnName": "会话时长中位数(小时)",
                      "type": "decimals",
                      "decimal": 2
                    }
                  ]
                }
              }
            },
            {
              "name": "OverallTableCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "titleEn": "Overall Playtime",
                  "titleCn": "在线时间总体表现",
                  "isHaveDiff": false,
                  "showStatistic": [
                    "avg"
                  ],
                  "formatType": "playtime",
                  "slotConfig": {
                    "isShowValueType": false,
                    "isShowMetricsSettings": false,
                    "isShowProgressBar": false,
                    "isShowdownloadConfig": false
                  },
                  "valueTypeConfig": {
                    "valueType": "dod"
                  },
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/engagement/active/overall_online_time",
                    "tableDownloadApi": "/api/v1/dashboard/pc/engagement/active/overall_online_time/download"
                  },
                  "componentMetrics": [
                    {
                      "metricKey": "dwm",
                      "reqMetricKey": "dwm",
                      "enPercentWidth": 155,
                      "cnPercentWidth": 155,
                      "enWidth": 155,
                      "cnWidth": 155,
                      "enName": "DAU",
                      "cnName": "日活跃",
                      "rainbowKey": "DAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "total_online_time_hour",
                      "reqMetricKey": "total_online_time_hour",
                      "enPercentWidth": 295,
                      "cnPercentWidth": 295,
                      "enWidth": 295,
                      "cnWidth": 295,
                      "enName": "Total duration of all sessions(h)",
                      "cnName": "总在线时长(小时)",
                      "rainbowKey": "Pc Total duration of all sessions(h)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "aot_hour",
                      "reqMetricKey": "aot_hour",
                      "enPercentWidth": 315,
                      "cnPercentWidth": 315,
                      "enWidth": 315,
                      "cnWidth": 315,
                      "enName": "Average Playtime(h)",
                      "cnName": "平均在线时长(小时)",
                      "rainbowKey": "Pc Avg.Playtime(h)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "median_online_time",
                      "reqMetricKey": "median_online_time",
                      "enPercentWidth": 315,
                      "cnPercentWidth": 315,
                      "enWidth": 315,
                      "cnWidth": 315,
                      "enName": "Median Playtime(h)",
                      "cnName": "在线时长中位数(小时)",
                      "rainbowKey": "Date Range Median Playtime",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "login_count",
                      "reqMetricKey": "login_count",
                      "enPercentWidth": 155,
                      "cnPercentWidth": 155,
                      "enWidth": 155,
                      "cnWidth": 155,
                      "enName": "Sessions",
                      "cnName": "登录次数",
                      "rainbowKey": "Sessions",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "average_online_time_per_login_hour",
                      "reqMetricKey": "average_online_time_per_login_hour",
                      "enPercentWidth": 275,
                      "cnPercentWidth": 275,
                      "enWidth": 275,
                      "cnWidth": 275,
                      "enName": "Average session length(h)",
                      "cnName": "单次登录平均在线时长(小时)",
                      "rainbowKey": "Pc Average session length(h)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "median_session_time",
                      "reqMetricKey": "median_session_time",
                      "enPercentWidth": 275,
                      "cnPercentWidth": 275,
                      "enWidth": 275,
                      "cnWidth": 275,
                      "enName": "Median Session Length(h)",
                      "cnName": "会话时长中位数(小时)",
                      "rainbowKey": "Pc Median Session Length(h)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            },
            {
              "name": "AveragePlaytimeDistributionCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/engagement/active/online_time_distribution",
                  "componentMetrics": {
                    "enName": "Playtime Distribution",
                    "cnName": "在线时长分布",
                    "type": "int",
                    "decimal": 0
                  }
                }
              }
            },
            {
              "name": "AveragePlaytimeByLevelCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/engagement/active/distribution_aot_level",
                  "componentMetrics": {
                    "enName": "Average Playtime By Level",
                    "cnName": "平均在线时长等级分布",
                    "type": "decimals",
                    "decimal": 2
                  }
                }
              }
            }
          ]
        }
      ]
    },
    {
      "id": "activeDegree",
      "tabName": "Active Degree",
      "tabNameCN": "活跃度分析",
      "isHaveNotification": true,
      "notificationPath": "/engagement/active/activeDegree",
      "path": "/engagement/active/activeDegree",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200703",
        "pageName": "engaementActiveActiveDegree",
        "extInfo": "engaementActiveActiveDegree",
        "pagePath": "/engagement/active/activeDegree"
      },
      "filters": [
        {
          "name": "ActiveDegreeFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/engagement/active/activeDegree",
          "componentList": [
            {
              "name": "ActiveDegreeContentCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "WeeklyActiveUsersServiceCo",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "data": {
                    "timeTypeIsShowCom": [
                      "week"
                    ]
                  },
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/engagement/active/degree_weekly"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "margin-b-10 margin-t-10",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "LoginActiveUsersCo",
                              "className": "",
                              "style": {},
                              "type": "view",
                              "props": {
                                "config": {
                                  "defaultAvtive": 1,
                                  "title": "Avg. Weekly Active Users Activity",
                                  "titleCN": "用户周均活跃登录行为",
                                  "titleDes": [
                                    {
                                      "title": "",
                                      "titleCn": "",
                                      "isRainbow": true,
                                      "rainbowKey": "Avg. Weekly Active Users Activity - Hover Info",
                                      "contentEn": "This card defaults to showing data for the latest natural week with available data and supports multi-week averages.<br><br>It counts players' active days per week and displays the number of players for each active day count.",
                                      "contentCn": "本卡片默认展示最新有数据的一个自然周数据，支持查看多周均值。<br><br>数据统计每个自然周中玩家活跃的天数，并显示每个活跃天数对应的玩家数。"
                                    },
                                  ],
                                  "subTitle": "",
                                  "subTitleCN": "",
                                  "isHaveSubTitle": true,
                                  "resKey": "active_user_activity",
                                  "componentMetrics": {
                                    "type": "int",
                                    "decimal": 0,
                                    "chartPercentDecimal": 1
                                  }
                                }
                              },
                              "children": []
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "ActiveUsersDaysCo",
                              "className": "",
                              "style": {},
                              "type": "view",
                              "props": {
                                "config": {
                                  "defaultAvtive": 0,
                                  "type": "weekly",
                                  "title": "Avg. Weekly Active Days",
                                  "titleCN": "用户周均活跃天数",
                                  "titleDes": [
                                    {
                                      "title": "",
                                      "titleCn": "",
                                      "isRainbow": true,
                                      "rainbowKey": "Avg. Weekly Active Users Activity - Hover Info",
                                      "contentEn": "This card defaults to showing data for the latest natural week with available data and supports multi-week averages.<br><br>It counts players' active days per week and displays the number of players for each active day count.",
                                      "contentCn": "本卡片默认展示最新有数据的一个自然周数据，支持查看多周均值。<br><br>数据统计每个自然周中玩家活跃的天数，并显示每个活跃天数对应的玩家数。"
                                    },
                                  ],
                                  "isHaveSubTitle": true,
                                  "resKey": "active_days",
                                  "componentMetrics": {
                                    "enName": "Login days Active Users",
                                    "cnName": "当天登录的活跃用户数",
                                    "type": "int",
                                    "decimal": 0,
                                    "chartPercentDecimal": 1
                                  }
                                }
                              },
                              "children": []
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "WeeklyActiveUsersServiceCo",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "data": {
                    "timeTypeIsShowCom": [
                      "week"
                    ]
                  },
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/engagement/active/degree_blweekly"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "ActiveUsersActivityCo",
                              "className": "",
                              "style": {},
                              "type": "view",
                              "props": {
                                "config": {
                                  "defaultAvtive": 1,
                                  "title": "Biweekly Active Users Activity",
                                  "titleCN": "活跃用户双周登录行为",
                                  "titleDes": [
                                    {
                                      "title": "",
                                      "titleCn": "",
                                      "isRainbow": true,
                                      "rainbowKey": "Biweekly Active Users Activity - Hover Info",
                                      "contentEn": "This card defaults to showing data for the latest two natural weeks with available data.<br><br>It counts players' active days per week and displays the number of players for each active day count.",
                                      "contentCn": "本卡片默认展示最新有数据的两个自然周数据；<br><br>数据统计每个自然周中玩家活跃的天数，并显示每个活跃天数对应的玩家数。"
                                    },
                                  ],
                                  "subTitle": "",
                                  "subTitleCN": "",
                                  "isHaveSubTitle": true,
                                  "resKey": "active_user_activity",
                                  "componentMetrics": {
                                    "enName": "Biweekly Active Users",
                                    "cnName": "双周活跃用户",
                                    "type": "int",
                                    "decimal": 0,
                                    "chartPercentDecimal": 1
                                  }
                                }
                              },
                              "children": []
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "ActiveUsersDaysCo",
                              "className": "",
                              "style": {},
                              "type": "view",
                              "props": {
                                "config": {
                                  "defaultAvtive": 0,
                                  "type": "biweekly",
                                  "title": "Biweekly Active Days",
                                  "titleCN": "用户双周活跃天数",
                                  "titleDes": [
                                    {
                                      "title": "",
                                      "titleCn": "",
                                      "isRainbow": true,
                                      "rainbowKey": "Biweekly Active Users Activity - Hover Info",
                                      "contentEn": "This card defaults to showing data for the latest two natural weeks with available data.<br><br>It counts players' active days per week and displays the number of players for each active day count.",
                                      "contentCn": "本卡片默认展示最新有数据的两个自然周数据；<br><br>数据统计每个自然周中玩家活跃的天数，并显示每个活跃天数对应的玩家数。"
                                    },
                                  ],
                                  "isHaveSubTitle": true,
                                  "resKey": "active_days",
                                  "componentMetrics": {
                                    "enName": "Login days Active Users",
                                    "cnName": "当天登录的活跃用户数",
                                    "type": "int",
                                    "decimal": 0,
                                    "chartPercentDecimal": 1
                                  }
                                }
                              },
                              "children": []
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "WeeklyActiveUsersServiceCo",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "data": {
                    "timeTypeIsShowCom": [
                      "month"
                    ]
                  },
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/engagement/active/degree_monthly"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "",
                      "type": "layout",
                      "style": {
                        "marginTop": 10
                      },
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "LoginActiveUsersCo",
                              "className": "",
                              "style": {},
                              "type": "view",
                              "props": {
                                "config": {
                                  "defaultAvtive": 1,
                                  "title": "Monthly Active Users Activity",
                                  "titleCN": "活跃用户月登录行为",
                                  "subTitle": "",
                                  "subTitleCN": "",
                                  "isHaveSubTitle": true,
                                  "resKey": "active_user_activity",
                                  "componentMetrics": {
                                    "type": "int",
                                    "decimal": 0,
                                    "chartPercentDecimal": 1
                                  }
                                }
                              },
                              "children": []
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "ActiveUsersDaysCo",
                              "className": "",
                              "style": {},
                              "type": "view",
                              "props": {
                                "config": {
                                  "defaultAvtive": 0,
                                  "title": "Monthly Active Days",
                                  "titleCN": "用户月活跃天数",
                                  "isHaveSubTitle": true,
                                  "resKey": "active_days",
                                  "componentMetrics": {
                                    "enName": "Login days Active Users",
                                    "cnName": "当天登录的活跃用户数",
                                    "type": "int",
                                    "decimal": 0,
                                    "chartPercentDecimal": 1
                                  }
                                }
                              },
                              "children": []
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};